import React from 'react';
import PropTypes from 'prop-types';
import RiseReport from '@/components/Report';
import { withRouter } from 'react-router-dom';
import { report } from '@/api';
import Title from '@/assets/images/report/title@2x.png';
import MapImg from '@/assets/images/report/map.png';
import Book from '@/assets/images/report/book@2x.png';
import Share from '@/assets/images/report/share@2x.png';
import './style.less';

@withRouter
class Report extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object,
  };

  state = {
    data: null,
    params: null,
  };

  componentDidMount() {
    this.setState({ params: this.props.match ? this.props.match.params : null }, () => {
      this.getReport();
    });
  }

  getReport = async () => {
    const { params } = this.state;
    const reportData = await report.list(params.id, params.attempt);
    this.init(reportData.data);
  };

  init = (reportData) => {
    this.setState({ data: reportData });
  }

  returnBook = () => {
    const { params } = this.state;
    this.props.history.push(`/cover/${params.id}/${params.attempt}/${params.stage}/${params.stageId}`);
  }

  returnMap = () => {
    const { params } = this.state;
    const stageId = params.stageId.replace('-', '/');
    this.props.history.push(`/stage/${params.stage}/${stageId}`);
  }

  handleShare = () => {
    const { params } = this.state;
    this.props.history.push(`/share/${params.id}/${params.attempt}/${params.stage}/${params.stageId}`);
  }

  render() {
    return (
      <div className="report-bg">
        <div className="report-container">
          <div className="report-content">
            <div className="report-header">
              <img src={Title} alt="" />
            </div>
            <RiseReport data={this.state.data} />
            <div className="share-pic">
              <img className="report-book" src={Book} alt="" onClick={this.returnBook} />
              <img className="report-share" src={Share} alt="" onClick={this.handleShare} />
              <img className="report-map" src={MapImg} alt="" onClick={this.returnMap} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Report;
